import type { PrivacyStrings } from "../../types";

export const mobilePrivacy: PrivacyStrings = {
  "title": "Privacidad de Cate Mobile",
  "lastUpdated": "Última actualización: 3 de noviembre de 2026",
  "sections": [
    {
      "title": "Sobre este suplemento",
      "paragraphs": [
        {
          "nodes": [
            "Este suplemento cubre Cate Mobile para iPhone. Léelo junto con la política principal de Cate, que identifica al responsable y su contacto, explica Cate Connect y los proveedores externos de IA, y establece tus derechos. Las visitas a esta página están cubiertas por la sección del sitio web de esa política."
          ]
        },
        {
          "nodes": [
            {
              "link": "Política de privacidad de Cate",
              "href": "/privacy"
            }
          ]
        }
      ]
    },
    {
      "title": "En tu dispositivo",
      "paragraphs": [
        {
          "nodes": [
            "Cate Mobile guarda los registros de espacios emparejados y los ajustes en tu dispositivo, y los secretos del dispositivo y de notificaciones en el llavero de iOS. Los archivos y las sesiones permanecen en el ordenador del runtime; la aplicación recibe el contenido necesario para mostrar y controlar el espacio mediante la conexión cifrada descrita en la política principal. Usa Forget para eliminar el registro local de emparejamiento. Esto no elimina archivos ni revoca el acceso del dispositivo en el ordenador; gestiona allí los dispositivos emparejados para revocarlo. Eliminar la aplicación no borra necesariamente las entradas del llavero."
          ]
        }
      ]
    },
    {
      "title": "Notificaciones push opcionales",
      "paragraphs": [
        {
          "nodes": [
            "Si permites notificaciones, Apple emite un token push. El runtime emparejado guarda el token y la clave usada para cifrar las notificaciones para tu dispositivo. Cate Connect reenvía el token y el contenido cifrado a Apple Push Notification service sin guardar los tokens push en su almacén de aplicación. La extensión de notificaciones descifra el contenido en tu dispositivo con su clave del llavero. Apple trata la información de entrega según su propia política de privacidad. Desactiva las notificaciones en Ajustes de iOS y gestiona el acceso de dispositivos emparejados en Cate en tu ordenador."
          ]
        },
        {
          "nodes": [
            {
              "link": "Política de privacidad de Apple",
              "href": "https://www.apple.com/legal/privacy/"
            }
          ]
        }
      ]
    },
    {
      "title": "Finalidad y opciones",
      "paragraphs": [
        {
          "nodes": [
            "Tratamos la información de emparejamiento y notificaciones para proporcionar las funciones solicitadas (art. 6.1.b RGPD). Las notificaciones también requieren tu permiso de iOS. Cate Mobile no incluye publicidad ni SDK de analíticas de terceros. Los informes de fallos y analíticas de escritorio descritos en la política principal se aplican a la aplicación de escritorio."
          ]
        }
      ]
    },
    {
      "title": "Contacto y tus derechos",
      "paragraphs": [
        {
          "nodes": [
            "Consulta la política principal de Cate para la dirección y contacto del responsable, tus derechos bajo el RGPD y la autoridad de control. Para consultas sobre registros de conexión, incluye el identificador del runtime correspondiente, pero no envíes claves privadas ni contenido del espacio de trabajo."
          ]
        },
        {
          "nodes": [
            {
              "link": "Política de privacidad de Cate",
              "href": "/privacy"
            }
          ]
        }
      ]
    }
  ]
};
